import FrameBorder from '@/component/FrameBorder';
import backgroundImg from '@assets/web-v3-images/FrameBorder.png';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AllCompete from './AllCompete';
import ButtonTab2 from './ButtonTab2';
import ButtonTab3 from './ButtonTab3';
import MyCompete from './MyCompete';
import { IS_UPDATE_VERSION_3_PROJECT } from '@/helper/const';

export default function Turn() {
	const [active, setActive] = useState("weekly");
	const [activeT, setActiveT] = useState(0);
	const { t } = useTranslation();
	const tabs = [
		{
			id: "weekly",
			label: t("history.weekly_reward"),
		},
		...(IS_UPDATE_VERSION_3_PROJECT
			? [
				{
					id: "daily",
					label: t("history.daily_reward"),
				},
			]
			: []),
	];

	const tabsT = [t("history.recent_guess"), t("history.my_guess")];

	return (
		<div className="min-h-0 flex flex-col">
			<ButtonTab2 data={tabs} active={active} setActive={setActive} />
			<FrameBorder fill>
				<div
					className="w-full bg-cover bg-no-repeat min-h-0 flex flex-col"
					style={{
						backgroundImage: `url(${backgroundImg})`,
					}}
				>
					<div className='mx-[8px] sm:mx-[30px] min-h-0 flex flex-col'>
						<div className='pt-5'>
							<ButtonTab3 activeT={activeT} setActiveT={setActiveT} tabsT={tabsT} />
						</div>
						{activeT === 0 ?
							<AllCompete active={active} activeT={activeT} setActive={setActive} />
							:
							<MyCompete active={active} activeT={activeT} setActive={setActive} />
						}
					</div>
				</div>
			</FrameBorder>
		</div>
	)
}
